// covered-by: frontends/carrie/src/ask-v2/review/__tests__/useAskV2ReviewVersionMarks.test.ts
import { useCallback, useMemo } from "react";

import { type ReviewVersionOption } from "./VersionPicker";

/**
 * The versions the workspace offers, falling back to the open review alone,
 * and the mark ("V2") each one reads under.
 */
export function useAskV2ReviewVersionMarks(
  versionOptions: readonly ReviewVersionOption[],
  review: { reviewId: string; title: string } | undefined,
) {
  const resolvedVersionOptions = useMemo(() => {
    if (versionOptions.length > 0) return versionOptions;
    if (!review) return [];
    return [{ reviewId: review.reviewId, title: review.title }];
  }, [review, versionOptions]);

  // The mark a review of this artwork reads under ("V2"), as the comparison
  // names its sides; none for a lineage of one, which has no other version.
  const versionMarkOf = useCallback(
    (id: string) => {
      if (resolvedVersionOptions.length < 2) return undefined;
      const at = resolvedVersionOptions.findIndex(
        (option) => option.reviewId === id,
      );
      if (at < 0) return undefined;
      return `V${resolvedVersionOptions[at].versionNumber ?? at + 1}`;
    },
    [resolvedVersionOptions],
  );

  return { resolvedVersionOptions, versionMarkOf };
}
